import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500 && !isDismissed) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (isDismissed) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white border-t border-border shadow-lg">
        <div className="flex items-center justify-between p-4">
          <div className="flex-1 mr-3">
            <p className="text-sm font-semibold text-foreground mb-1">Ready to get started?</p>
            <p className="text-xs text-muted-foreground">Get your RFQ within 24-48 hours</p>
          </div>
          <div className="flex items-center space-x-2">
            <Link to="/contact">
              <Button size="sm" className="bg-accent hover:bg-accent/90">
                Request Quote
              </Button>
            </Link>
            <button
              onClick={() => setIsDismissed(true)}
              className="p-2 hover:bg-secondary rounded-md transition-smooth"
            >
              <X className="h-4 w-4 text-muted-foreground" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
